<form id="form">
  <div [id]="captchaContainerId"></div>
</form>
